import Vue from 'vue'

export default {
  getPlantas: (empId) => Vue.http.get(`cliente/portal/opcao-planta/${empId}`).then(res => res.json()),

  save: (model) => Vue.http.post(`cliente/portal/opcao-planta/save`, model).then(res => res.json()),

  getPlantaSelecionada: (codCliente, codUsuario, empId) => (
    Vue.http.get(`cliente/portal/opcao-planta/${codCliente}/${codUsuario}/${empId}`).then(res => res.json())
  )
}
